<template>
  <div>
    <div class="row">
      <div class="flex md2 sm12 lg9">
        <h1>{{ $t('administrarivo.AddofertaPergunta') }}</h1>
      </div>
      <div v-if="novo" class="flex xs12 sm12 lg3">
        <va-button
          class="text-right"
          :color="BuNovo.color"
          :style="BuNovo"
        >{{ $t('Geral.Adicionar') }}</va-button>
      </div>
    </div>
    <div v-if="!novo">
      <form @submit.prevent="inserirOfertaP()">
        <div class="row">
          <!-- <div class="flex md2 sm12 lg3">
            <va-input
              :label="$t('forms.selects.simple')"
              v-model="AddAvac.nome"
              placeholder="Nome"
            />
          </div>

          <div class="flex md3 sm12 xs12">
            <va-select
              :label="$t('forms.selects.simple')"
              v-model="tipo_avaliacao"
              textBy="nome_disciplina"
              :options="getAllMateriasCurso"
              placeholder="Tipo de Avaliacao"
            />
          </div> -->
          <!-- <div class="flex md6 sm12 xs12 text--right">
            <va-button type="submit" class="text-right" color="dark">{{ $t('arealuno.Inserir') }}</va-button>
          </div> -->
          <!-- BOTOES CONTROLE -->
          <div class="flex md3 sm12 xs12 text--right">
            <va-button color="info" @click="abrirModal()">{{ $t('buttons.Adicionar') }}</va-button>
          </div>

          <!-- FIM CONTROLES -->
        </div>
      </form>
    </div>

    <va-data-table :fields="fields" :data="getOfertaPergunta" hoverable no-pagination>
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="actions" slot-scope="props">
    

        <va-button
          flat
          small
          color="info"
          @click="edit(props.rowData)"
          class="ma-0"
        >{{ $t('tables.edit') }}</va-button>
      </template>
    </va-data-table>

    <!-- Inicio Modal -->
    <div class="modal" v-show="showModal">
      <div class="modal-wrapper">
        <div class="modal-container scroll">
          <content select="modal-header ">
            <div class="modal-header">
              <h3 class="text-center">Slides</h3>
              <div class="row">
               <div class="flex md6 sm12 xs12">
                <va-button @click="showModal = false" color="info">Fechar</va-button>
              </div>
              
         <div class="flex md6 sm12 xs">
            <va-select
              :label="$t('forms.selects.simple')"
              v-model="disciplina"
              textBy="nome"
              :options="getdiciplicas"
              placeholder="discplinas"
            />
          </div> 
          </div>
            </div>
          </content>
          <hr />
          <br />
          <!-- Inicio Tabela -->
          <div class>
            <va-data-table :fields="fields" :data="getAllPergunta" hoverable no-pagination>
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>
              <template slot="actions" slot-scope="props">
                <va-button
                  small
                  color="info"
                  @click="inserirOfertaP(props.rowData)"
                  class="ma-0"
                >{{ $t('buttons.Adicionar') }}</va-button>
              </template>
            </va-data-table>
          </div>
          <!-- Fim Tabela -->
        </div>
      </div>
    </div>
    <!-- Fim Modal -->
  </div>
</template>

<script>
export default {
  name: "addprofessor",

  data() {
    return {
      
      
      BuNovo: {
        color: "info",
        width: "100%"
      },
      AddOfertP: {
      
        id: "",
        nome: "",
      
      },
      disciplina:{},
     showModal: false,
      novo: false


    };
  },
  created() {
    this.all();
    this.materiaCurso();
  },
  computed: {
     getOfertaPergunta(){
        return this.$store.state.avaliacao.allOfertaPerguntas;
    },
    getdiciplicas() {
      return this.$store.state.disciplinas.disciplinas;
    },
     getAllPergunta(){ 
        if (this.disciplina.id != '') {
          this.$store.dispatch('AllPerguntas',this.disciplina.id)
          this.disciplina.id = ''
        }
        return this.$store.state.avaliacao.AllPerguntas;
    },

    fields() {
      return [
        {
          name: "__slot:marker",
          width: "30px",
          dataClass: "text-center"
        },
        {
          name: "id",
          title:"id"
        },
        {
          name: "nome",
          title: "Pregunta"
        },
        {
          name: "__slot:actions",
          dataClass: "text-right"
        }
      ];
    },
    extras() {
      return [
        {
          name: "__slot:marker",
          width: "30px",
          dataClass: "text-center"
        },
        {
          name: "nome_disciplina",
          title: this.$t("tables.headings.name")
        },
        {
          name: "nome",
          title: this.$t("tables.headings.name")
        },
        {
          name: "data_abertura",
          title: this.$t("tables.headings.name")
        },
        {
          name: "data_encerramento",
          title: this.$t("tables.headings.name")
        },
        {
          name: "__slot:actions",
          dataClass: "text-right"
        }
      ];
    }
  },
  methods: {
    abrirModal() {
      this.showModal = true;
      this.$store.dispatch("allDisciplinas");
    },
    abrir_conteudos(value) {
      this.$store.dispatch("setMateria", value);
      this.$router.push({ name: "professor" });
    },
    all() {
      console.log(this.$store.state.avaliacao.setAvaliacao);
      this.$store.dispatch( "allOfertaPerguntasAvaliacao_2", this.$store.state.avaliacao.setAvaliacao
      );
    },
    materiaCurso() {
      this.$store.dispatch(
        "allMateriaCurso",
        this.$store.state.gradecurricular.dados_gradecurricular
          .grade_curricular_id
      );
    },
   async inserirOfertaP(value) {
     /// console.log(value);
      let insertOfertaP = {
      
        ead_avaliacao_id:  this.$store.state.avaliacao.setAvaliacao.id,
        ead_pergunta_id: value.id
      };
     await this.$store.dispatch("addOfertaPergunta", insertOfertaP);
   

        this.all();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.5s ease;

  &-wrapper {
    // display: table-cell;
    vertical-align: middle;
  }

  &-container {
    background: #fff;
    width: 950px;
    min-height: 400px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
    //  transition: all .3s ease;
    margin: auto;
    margin-top: 100px;
    padding: 20px 30px;
  }

  &-footer {
    margin-top: 15px;
  }

  &-enter,
  &-leave {
    opacity: 0;
  }

  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
